import React from "react";

import { FlexPackDetails } from "./FlexPackDetails";

import "./viewFlexPackWrapper.scss";

export default function ViewFlexPackWrapper({ flexPack }) {
  return <FlexPackDetails flexPack={flexPack} />;
}
